// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Pknj","dragIcon":"Choice_dragIcon__1y7U5","left":"Choice_left__1d5CT","input":"Choice_input__S5QnR"};